<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('uomCategory.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('uomCategory.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'uom-category-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              placeholder="Search"
              style="width: 300px;"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td class="kh-font">{{ record.uom_cat_name_kh }}</td>
          <td>{{ record.uom_cat_name_en }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="'Edit'"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="destroy(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'uomCategory',
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState('product/uomCategory', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.uomCategory.search
      },
      set(newValue) {
        this.$store.commit('product/uomCategory/SET_SEARCH', newValue)
        this.$store.commit('product/uomCategory/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('uomCategory.nameKh') },
        { name: this.$t('uomCategory.nameEn') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/uomCategory/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('product/uomCategory/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'uom-category-edit',
        params: { id: record.uom_cat_id }
      })
    },
    destroy(record) {
        record._deleting = true
        this.$store
          .dispatch('product/uomCategory/destroy', record.uom_cat_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/uomCategory/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
